import { render, staticRenderFns } from "./CalendarViewSelector.vue?vue&type=template&id=5ef71fb4&scoped=true"
import script from "./CalendarViewSelector.vue?vue&type=script&lang=js"
export * from "./CalendarViewSelector.vue?vue&type=script&lang=js"
import style0 from "./CalendarViewSelector.vue?vue&type=style&index=0&id=5ef71fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef71fb4",
  null
  
)

export default component.exports